var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date--separator",class:_vm.$dm('text-slate-700', 'dark:text-slate-200')},[_vm._v("\n  "+_vm._s(_vm.formattedDate)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }